import React from 'react';
import ProposalHeader from './ProposalHeader';
import ProposalClientSection from './ProposalClientSection';
import ProposalLineItems from './ProposalLineItems';
import ProposalFooter from './ProposalFooter';

const DEFAULT_TERMS = `Payment terms are Net 30 from job completion date. Storm and sewer lines are normally PVC or concrete and are usually unlocatable. Center Line Locating does not provide GPR or survey points for CAD. Each soft dig will have a data sheet provided with pertinent information regarding the exposed utility. DOT may require additional fees for permits which will be reflected in final invoice to client.`;

export default function ProposalDocument({ proposal, printRef }) {
  const standaloneItems = (proposal.items || []).map((item, idx) => ({
    ...item,
    id: item.id || idx
  }));

  const scopes = proposal.scopes || [];

  // Grand total = standalone items + all scope items
  const standaloneTotal = standaloneItems.reduce((sum, item) => {
    const qty = item.qty || item.quantity || 1;
    const price = item.price || item.unit_price || 0;
    return sum + (qty * price);
  }, 0);

  const scopesTotal = scopes.reduce((sum, scope) =>
    sum + (scope.items || []).reduce((s, item) => s + (item.total || (item.quantity || 1) * (item.unit_price || 0)), 0), 0);

  const grandTotal = standaloneTotal + scopesTotal;

  const terms = proposal.terms || DEFAULT_TERMS;

  return (
    <div 
      ref={printRef} 
      id="proposal-document" 
      className="bg-white w-full max-w-3xl shadow-xl rounded-lg overflow-hidden print:shadow-none print:rounded-none print:max-w-none" 
      style={{ fontFamily: "'Inter', system-ui, sans-serif" }}
    >
      <ProposalHeader proposal={proposal} />
      
      <div className="px-6 py-4">
        <ProposalClientSection proposal={proposal} />
        
        <ProposalLineItems 
          standaloneItems={standaloneItems} 
          scopes={scopes}
          grandTotal={grandTotal} 
        />
        
        {/* Notes */}
        {proposal.notes && (
          <div className="mb-3">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Notes</p>
            <p className="text-[11px] text-slate-600 leading-relaxed">{proposal.notes}</p>
          </div>
        )}
        
        {/* Terms - Compact single paragraph */}
        <div className="mb-3 p-2 bg-slate-50 rounded">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Terms & Conditions</p>
          <p className="text-[9px] text-slate-500 leading-relaxed">{terms}</p>
        </div>
      </div>
      
      <ProposalFooter proposal={proposal} />
    </div>
  );
}
